import { render, staticRenderFns } from "./payment-iq.vue?vue&type=template&id=3b690d5b&scoped=true"
import script from "./payment-iq.vue?vue&type=script&lang=js"
export * from "./payment-iq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b690d5b",
  null
  
)

export default component.exports